import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var BuildingIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsxs("g", {
                fill: "currentColor",
                fillRule: "evenodd",
                clipPath: "url(#a)",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M.75 24a.75.75 0 0 1 0-1.5H2V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v19.5h1.25a.75.75 0 0 1 0 1.5H.75ZM19 1.52H5A1.48 1.48 0 0 0 3.52 3v19.48H10V19a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3.48h6.48V3A1.48 1.48 0 0 0 19 1.52Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.25 6A.75.75 0 0 1 8 5.25h2a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6ZM7.25 10A.75.75 0 0 1 8 9.25h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM13.25 6a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM13.25 10a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM7.25 14a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM13.25 14a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ _jsx("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    }));
};
